import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';

import { IContentfulImageBlock } from '../../utils/fragments/ImageBlockFragment';

import { DoorWidget } from './DoorWidget';

/**
 * DoorWidgetWithQuery is a wrapper component that fetches door design sections
 * using a static query. This is useful for rendering the DoorWidget in contexts
 * where page-level GraphQL data is not available (e.g., RichTextRender).
 */
export const DoorWidgetWithQuery: React.FunctionComponent = () => {
  const data = useStaticQuery<{
    doorDesignSections: {
      nodes: IContentfulImageBlock[];
    };
  }>(graphql`
    query DoorWidgetQuery {
      doorDesignSections: allContentfulImageBlock(
        filter: { slug: { regex: "/^doors/" } }
        sort: { fields: slug, order: ASC }
      ) {
        nodes {
          title
          slug
          images {
            title
            contentful_id
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
  `);

  const doorSections = data.doorDesignSections.nodes;
  const step1Block = doorSections.find((node) => node.slug === 'doors/step-1');
  const designSections = doorSections.filter(
    (node) => node.slug !== 'doors/step-1'
  );

  return <DoorWidget step1Block={step1Block} designSections={designSections} />;
};
